import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadShipTo,
} from "@insite/client-framework/Store/Pages/OrderConfirmation/Handlers/LoadCart";
import loadExpediteShipping from "@TKCCP/Store/Data/ExpediteShipping/Handlers/LoadExpediteShipping";



addToChainAfter(chain, DispatchCompleteLoadShipTo, props => {
    if (props.parameter.cartId) {
        props.dispatch(loadExpediteShipping({ cartId: props.parameter.cartId }));
        
    }
});
